
import inputmultiple_onLoad from "./inputmultiple/onload"

const onLoad = () => {
  inputmultiple_onLoad()
}

export default onLoad
